(function ($) {
	'use strict';

	$(function () {

		//add responsive menu icon/button
		//#responsive-check element is dummy element which is given properties based on media queries and those properties are queried by jQuery
		$('.site-nav-menus').prepend('<div id="responsive-menu-icon"><span class="menu-open">Menu</span><span class="menu-close">Close</span></div><div id="responsive-check"></div>');

		const headerContentWidth = $('.title-area').outerWidth(true) + $('.header-widget-area').width();

		/**
		 * Hide header widgets and move top menu to responsive menu
		 * if there's not enough room to show them
		 */
		const showHideHeaderWidgets = function () {
			const $body = $('body');
			const $siteHeader = $('.site-header .wrap');
			const $topMenus = $('.site-top-menus');
			if (headerContentWidth > $siteHeader.width()) {
				$body.addClass('hide-header-widgets');
				$topMenus.detach().insertBefore('#genesis-nav-primary');
			} else {
				$body.removeClass('hide-header-widgets');
				$topMenus.detach().appendTo($siteHeader);
			}
		};
		showHideHeaderWidgets();
		$(window).resize(showHideHeaderWidgets);

		/**
		 * Do responsive menu if any menu items would be hidden because there are too many
		 *
		 * We tell this based on whether menu items wrap, making menu higher than it should be.
		 * Primary menu should be 56px so we check if height is a little more.
		 * If responsive menu should be shown, we add a body class which uses same CSS as normal
		 * media query for the responsive menu (@see _header.sass)
		 */
		const doResponsiveMenu = function () {
			const $body = $('body');
			if ($('.nav-primary .menu').height() > 60) {
				$body.addClass('show-responsive-menu');
			} else {
				$body.removeClass('show-responsive-menu');
			}
		};
		doResponsiveMenu();
		$(window).resize(doResponsiveMenu);

		/**
		 * Fix menu bar to top of screen when scrolling down
		 */
		const fixMenu = function () {
			const $body = $('body');
			if ($(document).scrollTop() > $('.site-header').height() || $body.hasClass('force-fixed-menu')) {
				$body.addClass('fixed-menu');
			} else {
				$body.removeClass('fixed-menu');
			}
		};
		fixMenu();
		$(window).scroll(fixMenu);

		/**
		 * Show/hide responsive menu
		 */
		$('#responsive-menu-icon').find('span').click(function () {

			//show/hide the primary & secondary menus
			$('.nav-primary .wrap').slideToggle();
			$('.nav-secondary .wrap').slideToggle();

			//and show top menu if it has been moved to the site-nav-menus div
			if ($('.site-nav-menus .site-top-menus').length) {
				$('.site-top-menus').slideToggle(function () {
					if ($(this).is(':visible')) {
						$(this).css('display', 'flex');
					}
				});
			}

			//alternate between menu/close buttons
			$(this).parent().children().toggle();

		});

		/**
		 * Show/hide search field in menu bar
		 */
		$('.search-menu-button').on('click', function (e) {
			e.preventDefault();
			$('.search').addClass('search-active');
			$('.search input[type=search]').focus();
			$(this).hide();
			return false;
		});
		$('.search input[type=search]').on('blur', function () {
			$('.search-menu-button').show();
			$('.search').removeClass('search-active');
		});
	});

}(GEN$));
